import { 
  GET_OEM_PARTNER_REQUEST, 
  GET_OEM_PARTNER_SUCCESS, 
  GET_OEM_PARTNER_FAILURE,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE,
  CLEAR_OEM_DATA
} from '../constants/oemConstants';
import { LOGOUT_SUCCESS } from '../constants/authConstants';

const initialState = {
  loading: false,
  data: null,
  error: null,
  emailLoading: false,
  emailError: null,
  emailSuccess: false
};

const oemReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OEM_PARTNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_OEM_PARTNER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case GET_OEM_PARTNER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case SEND_EMAIL_REQUEST:
      return {
        ...state,
        emailLoading: true,
        emailError: null,
        emailSuccess: false
      };

    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoading: false,
        emailError: null,
        emailSuccess: true
      };

    case SEND_EMAIL_FAILURE:
      return {
        ...state,
        emailLoading: false,
        emailError: action.payload
      };

    case CLEAR_OEM_DATA:
    case LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default oemReducer;